// extracted by mini-css-extract-plugin
export var h1 = "Heading-module--h1--wtbmq";
export var h2 = "Heading-module--h2--1NEYP";
export var h3 = "Heading-module--h3--1Rd2k";
export var h4 = "Heading-module--h4--3_JUp";